import { render, staticRenderFns } from "./SingleMenuItem.vue?vue&type=template&id=bc843628"
import script from "./SingleMenuItem.vue?vue&type=script&lang=ts"
export * from "./SingleMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports